
<p-table
  #roleTable
  [lazy]="false"
  [(selection)]="selectedRolesModel"
  [value]="assignablesRoles"
  [scrollable]="true"
  (selectionChange)="onSelectionChange($event)"
  [filterDelay]="200">
  <ng-template pTemplate="header">
    <tr>
      <th style="width: 4rem">
        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
      </th>
      <th>Name</th>
      <th></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-role>
    <tr>
      <td>
        <p-tableCheckbox [value]="role"></p-tableCheckbox>
      </td>
      <td>{{role.label}}</td>
      <td class="text-right">
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="2" class="emptyMessage">Keine Rollen gefunden.</td>
    </tr>
  </ng-template>
</p-table>